import React, { Component } from 'react';

class IconTimerMedium extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="19.201" height="19.201" viewBox="0 0 19.201 19.201"><path className="a" d="M11.909,18.311a1.066,1.066,0,1,0,1.066-1.066A1.07,1.07,0,0,0,11.909,18.311Zm0-14.936V7.64h2.132V5.6a7.463,7.463,0,1,1-8.534,7.38A7.388,7.388,0,0,1,7.192,8.258l5.783,5.783,1.5-1.5L7.224,5.286v.023a9.58,9.58,0,1,0,5.751-1.934Zm7.468,9.6a1.066,1.066,0,1,0-1.066,1.066A1.07,1.07,0,0,0,19.378,12.976Zm-12.8,0A1.066,1.066,0,1,0,7.64,11.909,1.07,1.07,0,0,0,6.574,12.976Z" transform="translate(-3.375 -3.375)" fill="#4e5b66" /></svg>
        );
    }
}

export default IconTimerMedium;